import React from 'react';
import StringUtils from '../utils/stringutils.js';
import $ from 'jquery';
import { MainView, SGValueBox, SGValueOverlay, SGQuestion, AlertBox } from '../components/components.js';

class StrategicGoals extends React.Component {

	constructor(props) {
		super(props);

		this.getSGs = this.getSGs.bind(this);
		this.openValueOverlay = this.openValueOverlay.bind(this);
		this.cancelValueOverlay = this.cancelValueOverlay.bind(this);
		this.saveValueOverlay = this.saveValueOverlay.bind(this);
		this.onQuestionAnswer = this.onQuestionAnswer.bind(this);
		this.onSave = this.onSave.bind(this);

		this.state = {
			strategic_goals : false,
			overlay_open : '',
			alertType : '',
			alertContent : '',
			modified : false
		};
	}

	componentDidMount() {

		if(this.state.strategic_goals === false) {
			this.getSGs();
		}
	}

	getSGs() {
		var comp = this;

		var callback = function(response) {
			if(response.code === 200) {
				comp.setState({
					strategic_goals : response.data.strategic_goals
				});
			}
		};

		window._fiSponsor.GET_STRATEGIC_GOALS(callback);
	}

	openValueOverlay(e) {
		var dataId = e.currentTarget.getAttribute('data-id');

		this.setState({overlay_open : dataId});
	}

	cancelValueOverlay(e) {
		this.setState({overlay_open : ''});
	}

	saveValueOverlay(e) {
		var newStrategicGoals = this.state.strategic_goals;
		if(this.state.overlay_open === 'user_goal') {
			newStrategicGoals.user_goal = $('[name=SG-Value-Overlay]').val();
			newStrategicGoals.user_goal_target = $('#q-selector').val() + ' ' + $('#year-selector').val();
			newStrategicGoals.last_user_goal_date = new Date('mm/dd/YYYY');
			newStrategicGoals.last_user_goal_updater = window._fiUser.firstname + ' ' + window._fiUser.lastname;
			
		}
		else if (this.state.overlay_open === 'program_goal') {
			newStrategicGoals.program_goal = $('[name=SG-Value-Overlay]').val();
			newStrategicGoals.program_goal_target = $('#q-selector').val() + ' ' + $('#year-selector').val();
			newStrategicGoals.last_program_goal_date = new Date('mm/dd/YYYY');
			newStrategicGoals.last_program_goal_updater = window._fiUser.firstname + ' ' + window._fiUser.lastname;
		}

		//console.log(newStrategicGoals);
		this.setState({
			strategic_goals : newStrategicGoals,
			overlay_open  : '',
			modified : true
		});
	}

	onQuestionAnswer(type, answer) {
		//console.log(type);
		//console.log(answer);
		var newStrategicGoals = this.state.strategic_goals;

		if(type === 'select_priority' || type === 'competitors')  answer = answer.join();
		newStrategicGoals[type] = answer;

		this.setState({strategic_goals : newStrategicGoals, modified : true});
	}

	onSave(e) {
		window._fiSponsor.sponsors[0].strategic_goals = this.state.strategic_goals;

		var comp = this, 
			callback = function(response) {
				if(response.code === 200) {
					console.log('Success');
					comp.setState({
						alertType : 'Success',
						alertContent : 'Saved! Successfully!',
						modified : false
					});
				}
				else  {
					comp.setState({
						alertType : 'Error',
						alertContent : 'We encountered a problem! ' + response.detail
					});
				}
		};

		window._fiSponsor.UPDATE_STRATEGIC_GOALS(callback, this.state.strategic_goals.marketing_plan);
	}

	render() {
		var location = 'Strategic Goals';

		window._fiSponsor.loadSessionInfo();

		var strategic_goals = this.state.strategic_goals;

		if(strategic_goals === false) {
			return (<MainView location={location} amount={window._fiSponsor.sponsors[0].total_saved} content={(<div className="App-LoadLayer"><div className="App-Loader login"></div></div>)} />);
		}


		/* props:
	type (required string)
	title (required string)
	onSubmit (required function)
	onCancel (required function)
	hide (required boolean)
	input_field_val (required numeric)
*/
		var valueOverlay = '', fieldVal, q_val, y_val;

		switch(this.state.overlay_open) {
			case 'user_goal':
				var user_goal_target = strategic_goals.user_goal_target;
				fieldVal = StringUtils.isFilled(strategic_goals.user_goal) ? strategic_goals.user_goal : '0';
				q_val = user_goal_target.substr(user_goal_target.indexOf('Q'), 2);
				y_val = user_goal_target.substr(user_goal_target.indexOf(' ') + 1, 4);

				valueOverlay = (				
					<SGValueOverlay
						hide={false}
						type='users'
						title='Next User Goal'
						onSubmit={this.saveValueOverlay}
						onCancel={this.cancelValueOverlay}
						input_field_val={fieldVal}
						q_val={q_val}
						y_val={y_val}
					/>
				);
				break;
			case 'program_goal':
				fieldVal = StringUtils.isFilled(strategic_goals.program_goal) ? strategic_goals.program_goal : '0';
				q_val = strategic_goals.program_goal_target.substr(strategic_goals.program_goal_target.indexOf('Q'), 2);
				y_val = strategic_goals.program_goal_target.substr(strategic_goals.program_goal_target.indexOf(' ') + 1, 4);
				valueOverlay = (				
					<SGValueOverlay
						hide={false}
						type='program'
						title='Program Goal'
						onSubmit={this.saveValueOverlay}
						onCancel={this.cancelValueOverlay}
						input_field_val={fieldVal}
						q_val={q_val}
						y_val={y_val}
					/>
				);
				break;
			default: 
				valueOverlay = (				
					<SGValueOverlay
						hide={true}
						type='users'
						title='hidden'
						onSubmit={this.saveValueOverlay}
						onCancel={this.cancelValueOverlay}
						input_field_val={0}
					/>
				);
				break;
		}
		/* add_class (optional)
 * side_title (required string)
 * content_text (required string)
 * onClick (required function)
 * sub_content_text (required string)
 * last_update_text (required string)
 */		
 		var userSubContentText = (StringUtils.isFilled(strategic_goals.user_goal_target)) ? "by end of " + strategic_goals.user_goal_target : '',
 			programSubContentText = (StringUtils.isFilled(strategic_goals.program_goal_target)) ? "by end of " + strategic_goals.program_goal_target : '',
 			userUpdateText = (StringUtils.isFilled(strategic_goals.last_user_goal_date)) ? "Last updated " + strategic_goals.last_user_goal_date + " by " + strategic_goals.last_user_goal_updater : '',
 			programUpdateText = (StringUtils.isFilled(strategic_goals.last_program_goal_date)) ? "Last updated " + strategic_goals.last_program_goal_date + " by " + strategic_goals.last_program_goal_updater : '',
 			select_priority = (Array.isArray(strategic_goals.select_priority)) ? strategic_goals.select_priority : (StringUtils.isFilled(strategic_goals.select_priority)) ? strategic_goals.select_priority.split(',') : '',
 			competitors = (Array.isArray(strategic_goals.competitors)) ? strategic_goals.competitors : (StringUtils.isFilled(strategic_goals.select_priority)) ? strategic_goals.competitors.split(',') : '',
 			marketing_plan = (Object.keys(strategic_goals).indexOf('marketing_plan') > -1) ? strategic_goals.marketing_plan : '',
 			saveOrSaved = (this.state.alertType === 'Success' && !this.state.modified) ? 'Saved' : 'Save';

		var content = (
			<div className="SG-Main-View">
				{valueOverlay}
				<AlertBox type={this.state.alertType} content={this.state.alertContent} />
				<div className="SG-Value-Boxes">
					<SGValueBox 
						key='User_Goal'
						dataId='user_goal'
						side_title={"Next user goal"} 
						content_text={strategic_goals.user_goal}
						onClick={this.openValueOverlay}
						sub_content_text= {userSubContentText}
						last_update_text={userUpdateText}
					/>
					<SGValueBox
						key='Program_Goal'
						dataId='program_goal'
						side_title={"Program goal"}
						content_text={strategic_goals.program_goal}
						onClick={this.openValueOverlay}
						sub_content_text={programSubContentText}
						last_update_text={programUpdateText}
					/>
				</div>
				<div className="SG-Questions-Prompt">
					Please answer a few questions about what your team will be focusing on over the next 12 months, this will help us gather the most useful data about your users to tailor your Dashboard experience to the needs of {window._fiSponsor.sponsors[0].name}
				</div>
				<SGQuestion
					key='q1'
					dataId='fill_priority'
					question_num='1' 
					question_text='What is the number one priority of your FI (fill in)' 
					response_type='textarea' 
					answer={strategic_goals.fill_priority}
					onAnswer={this.onQuestionAnswer} 
				/>
				<SGQuestion 
					key='q2'
					dataId='select_priority'
					question_num='2' 
					question_text='What has your FI prioritized for the next 12 months? (select all that apply)' 
					response_type='checkbox' 
					possible_answers={['Deposit Growth', 'Loan Growth', 'Investment Services', 'Non-interest Income', 'Credit Card Portfolio', 'Private Banking', 'Small Business Banking', 'Digital Channel Strategy']}
					answer={select_priority}
					onAnswer={this.onQuestionAnswer}
				/>
				<SGQuestion
					key='q3'
					dataId='competitors'
					question_num='3'
					question_text='What competitors are you most concerned with?'
					response_type='checkbox'
					possible_answers={['Local Credit Unions / Community Banks', 'Regional Competitors', 'Large banks/CUs', 'Non-banking Financial Institutions']}
					answer={competitors}
					onAnswer={this.onQuestionAnswer}
				/>
				<SGQuestion
					key='q4'
					dataId='marketing_plan'
					question_num='4'
					question_text='Upload your strategic marketing plan, this will be kept strictly confidential but will help HTMA support your strategic goals.'
					response_type='file'
					answer={marketing_plan}
					onAnswer={this.onQuestionAnswer}
					url={strategic_goals.marketing_plan_url}
				/>
				<div className="SG-Questions-Prompt">
					Please fill in the below FI Information. This will help us to better understand {window._fiSponsor.sponsors[0].name}
				</div>
				<SGQuestion
					key='q5'
					dataId='address'
					question_num='5'
					question_text='What is your Main Office Address?'
					response_type='textarea'
					answer={strategic_goals.address}
					onAnswer={this.onQuestionAnswer}
				/>
				<SGQuestion
					key='q6'
					dataId='asset_size'
					question_num='6'
					question_text='What is the approximate asset size of your FI?'
					response_type='numinput'
					answer={strategic_goals.asset_size}
					onAnswer={this.onQuestionAnswer}
				/>
				<SGQuestion
					key='q7'
					dataId='num_employees'
					question_num='7'
					question_text='How many employees are working for your FI?'
					response_type='numinput'
					answer={strategic_goals.num_employees}
					onAnswer={this.onQuestionAnswer}
				/>
				<SGQuestion
					key='q8'
					dataId='core_provider'
					question_num='8'
					question_text='Who is your core provider?'
					response_type='textinput'
					answer={strategic_goals.core_provider}
					onAnswer={this.onQuestionAnswer}
				/>
				<SGQuestion
					key='q9'
					dataId='mobile_provider'
					question_num='9'
					question_text='Who is your mobile banking provider?'
					response_type='textinput'
					answer={strategic_goals.mobile_provider}
					onAnswer={this.onQuestionAnswer}
				/>
				<SGQuestion
					key='q10'
					dataId='online_provider'
					question_num='10'
					question_text='Who is your online banking provider?'
					response_type='textinput'
					answer={strategic_goals.online_provider}
					onAnswer={this.onQuestionAnswer}
				/>
				<SGQuestion
					key='q11'
					dataId='atm_vendor'
					question_num='11'
					question_text='Who is your ATM vender?'
					response_type='textinput'
					answer={strategic_goals.atm_vendor}
					onAnswer={this.onQuestionAnswer}
				/>
				<SGQuestion
					key='q12'
					dataId='customer_demographics'
					question_num='12'
					question_text='Please provide a summary of your customer demographics'
					response_type='textarea'
					answer={strategic_goals.customer_demographics}
					onAnswer={this.onQuestionAnswer}
				/>
				<div className="SG-Questions-Prompt">
					Total account counts
				</div>
				<SGQuestion
					key='q13'
					dataId='total_dda'
					question_num='13'
					question_text='DDA'
					response_type='numinput'
					answer={strategic_goals.total_dda}
					onAnswer={this.onQuestionAnswer}
				/>
				<SGQuestion
					key='q14'
					dataId='total_savings'
					question_num='14'
					question_text='Savings'
					response_type='numinput'
					answer={strategic_goals.total_savings}
					onAnswer={this.onQuestionAnswer}
				/>
				<SGQuestion
					key='q15'
					dataId='total_mortgage'
					question_num='15'
					question_text='Mortgage'
					response_type='numinput'
					answer={strategic_goals.total_mortgage}
					onAnswer={this.onQuestionAnswer}
				/>
				<SGQuestion
					key='q16'
					dataId='total_personal_loan'
					question_num='16'
					question_text='Personal Loan'
					response_type='numinput'
					answer={strategic_goals.total_personal_loan}
					onAnswer={this.onQuestionAnswer}
				/>
				<SGQuestion
					key='q17'
					dataId='total_wealth_management'
					question_num='17'
					question_text='Wealth Management'
					response_type='numinput'
					answer={strategic_goals.total_wealth_management}
					onAnswer={this.onQuestionAnswer}
				/>
				<div className="SG-Questions-Prompt">
					Total customer age counts
				</div>
				<SGQuestion
					key='q18'
					dataId='total_eighteen_to_twentyfour'
					question_num='18'
					question_text='Aged 18-24'
					response_type='numinput'
					answer={strategic_goals.total_eighteen_to_twentyfour}
					onAnswer={this.onQuestionAnswer}
				/>
				<SGQuestion
					key='q19'
					dataId='total_twentyfive_to_thirtyfour'
					question_num='19'
					question_text='Aged 25-34'
					response_type='numinput'
					answer={strategic_goals.total_twentyfive_to_thirtyfour}
					onAnswer={this.onQuestionAnswer}
				/>
				<SGQuestion
					key='q20'
					dataId='total_thirtyfive_to_fortyfour'
					question_num='20'
					question_text='Aged 35-44'
					response_type='numinput'
					answer={strategic_goals.total_thirtyfive_to_fortyfour}
					onAnswer={this.onQuestionAnswer}
				/>
				<SGQuestion
					key='q21'
					dataId='total_fortyfive_to_fiftyfour'
					question_num='21'
					question_text='Aged 45-54'
					response_type='numinput'
					answer={strategic_goals.total_fortyfive_to_fiftyfour}
					onAnswer={this.onQuestionAnswer}
				/>
				<SGQuestion
					key='q22'
					dataId='total_fiftyfive_to_sixtyfour'
					question_num='22'
					question_text='Aged 55-64'
					response_type='numinput'
					answer={strategic_goals.total_fiftyfive_to_sixtyfour}
					onAnswer={this.onQuestionAnswer}
				/>
				<SGQuestion
					key='q23'
					dataId='total_sixtyfive_to_seventyfour'
					question_num='23'
					question_text='Aged 65-74'
					response_type='numinput'
					answer={strategic_goals.total_sixtyfive_to_seventyfour}
					onAnswer={this.onQuestionAnswer}
				/>
				<SGQuestion
					key='q24'
					dataId='total_seventyfive_plus'
					question_num='24'
					question_text='Aged 75+'
					response_type='numinput'
					answer={strategic_goals.total_seventyfive_plus}
					onAnswer={this.onQuestionAnswer}
				/>
				<div className={saveOrSaved + "-Area"}>
					<button className="Save-Button" onClick={this.onSave}>{saveOrSaved}</button>
				</div>
			</div>
		);

		return (
		    <MainView location={location} amount={window._fiSponsor.sponsors[0].total_saved} content={content} />
		);
	}
}

export default StrategicGoals;